import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CoreModule } from '../../../core/core.module';
import { AppModuleGlobalShared } from '../../../../app.module.global';
import { AltaUsuariosExternosService } from './altausuariosexternos.service';
import { AltaUsuariosExternosEditComponent } from './altausuariosexternos-edit-component';
import { AltaUsuariosExternosRoutingModule } from './altausuariosexternos-routing.module';

@NgModule({
    declarations: [AltaUsuariosExternosEditComponent],
    imports: [CoreModule, AppModuleGlobalShared, CommonModule, FormsModule, ReactiveFormsModule, AltaUsuariosExternosRoutingModule],
    providers: [AltaUsuariosExternosService],
})
export class UsuariosExModule {}
